import { render, staticRenderFns } from "./CertificatePinModal.component.vue?vue&type=template&id=16cde63c"
import script from "./CertificatePinModal.component.vue?vue&type=script&lang=js"
export * from "./CertificatePinModal.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports